import { useState, React, useEffect } from "react";
import { UserAvatar, } from '@carbon/react/icons';
import { Header, HeaderContainer, HeaderName, HeaderGlobalBar, HeaderGlobalAction, Grid, Column, SwitcherItem, HeaderPanel, SideNav, SideNavItems, SideNavMenuItem, SideNavLink, SideNavDivider, SideNavMenu } from '@carbon/react';
import { Link } from 'react-router-dom';
import { Logout, Fade } from '@carbon/react/icons';
import dayjs from "dayjs";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const HeaderCustom = ({ translation }) => {

    const [user, setUser] = useState(false);
    const [isRecibosNomina, setIsRecibosNomina] = useState(false);
    const [isAdmon, setIsAdmon] = useState(false);
    const [isAdmonUsuEmp, setIsAdmonUsuEmp] = useState(false);
    const [isAdmonPerfiles, setIsAdmonPerfiles] = useState(false);
    const [isAdmonPermisos, setIsAdmonPermisos] = useState(false);
    const [isAdmonCargaMasiva, setIsAdmonCargaMasiva] = useState(false);

    const nombre = sessionStorage.getItem('nombre');
    const puesto = sessionStorage.getItem('puesto');
    const rfc = sessionStorage.getItem('rfc');

    const validaPermisos = () => {
        var verMenuAdmon = false;
        let admonRecibosNomina = cookies.get("modRecibosNomina");
        let admonUsuarioEmpleados = cookies.get("modUsuarioEmpleados");
        let admonPerfiles = cookies.get("modPerfiles");
        let admonPermiso = cookies.get("modPermisos");
        let admonCargaMasiva = cookies.get("modCargaMasiva");

        if(admonRecibosNomina != undefined && admonRecibosNomina.length > 0){
            setIsRecibosNomina((admonRecibosNomina[0].PerfilModuloConsulta == 1)?true:false);   
        }

        if(admonUsuarioEmpleados != undefined && admonUsuarioEmpleados.length > 0){
            setIsAdmonUsuEmp((admonUsuarioEmpleados[0].PerfilModuloConsulta == 1)?true:false);
            verMenuAdmon = true;
        }

        if(admonPerfiles != undefined && admonPerfiles.length >= 0){
            var verPerfil = false;
            if(admonPerfiles.length > 0){
                verPerfil =  (admonPerfiles[0].PerfilModuloConsulta == 1)?true:false;
                verMenuAdmon = true;
            }
            setIsAdmonPerfiles(true);
            cookies.set("verPerfil", verPerfil);
        }

        if(admonPermiso != undefined && admonPermiso.length >= 0){
            var verPermisos = false;
            if(admonPermiso.length > 0){ 
                verPermisos = (admonPermiso[0].PerfilModuloConsulta == 1)?true:false;
                verMenuAdmon = true;
            }
            setIsAdmonPermisos(true);
            cookies.set("verPermisos", verPermisos);
        } 

        if(admonCargaMasiva != undefined && admonCargaMasiva.length >= 0){
            var verCargaMasiva = false;
            if(admonCargaMasiva.length > 0){
                verCargaMasiva = (admonCargaMasiva[0].PerfilModuloConsulta == 1)?true:false;
                verMenuAdmon = true;
            }
            setIsAdmonCargaMasiva(true);
            cookies.set("verCargaMasiva", verCargaMasiva);
        }

        setIsAdmon(verMenuAdmon);
    }

    const userMostrar = () => {
        if (user === false) {
            setUser(true)
        } else {
            setUser(false)
        }
    }


    const logout = () => {

        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            sessionStorage.removeItem(key);
        }

        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }

        window.location.href = "/#/";
    }

    useEffect(() => {
        validaPermisos();

    }, []);

    return <>

        <HeaderContainer render={({ isSideNavExpanded, onClickSideNavExpand }) => (
            <Header aria-label="HumanSite">
                <HeaderName as={Link} prefix="" to="/recibos">HumanSite | GEB</HeaderName>
                <HeaderGlobalBar>
                    <HeaderGlobalAction aria-label="Cuenta de usuario" tooltipAlignment="center" onClick={userMostrar}>
                        <UserAvatar size={20} />
                    </HeaderGlobalAction>
                </HeaderGlobalBar>
                <SideNav
                    aria-label="Side navigation"
                    isRail
                    expanded={isSideNavExpanded}
                    onOverlayClick={onClickSideNavExpand}
                >
                <SideNavItems>
                    {(isRecibosNomina) &&
                        <SideNavLink
                            renderIcon={Fade}
                            as={Link} to="/recibos">
                            Inicio
                        </SideNavLink>
                    }
                     {(isAdmon) && <>
                        <br/>
                        <SideNavDivider />
                        <br/>
                            <SideNavMenu renderIcon={Fade} title="Administración" >
                                {(isAdmonUsuEmp || isAdmonCargaMasiva) &&
                                    <SideNavMenuItem 
                                        as={Link} to="/admonUsuarios" >
                                    Usuarios y Empleados
                                    </SideNavMenuItem>
                                }
                                {(isAdmonPerfiles || isAdmonPermisos) &&
                                    <SideNavMenuItem
                                        as={Link} to="/admonPerfiles" >
                                        Perfiles y permisos
                                    </SideNavMenuItem>
                                }
                            </SideNavMenu>
                        </>
                    }
                </SideNavItems>
            </SideNav>

                {/** DATOS DE USUARIO */}
                {user &&
                    <HeaderPanel aria-label="Header Panel" expanded>
                        <SwitcherItem>
                            <Grid>
                                <Column lg={16} md={16} sm={16}>
                                    <p className="info nombre"> {nombre} </p>
                                </Column>
                            </Grid>
                        </SwitcherItem>
                        <hr />
                        {rfc != "" &&
                            <>
                                <SwitcherItem>
                                    <Grid>
                                        <Column lg={16} md={16} sm={16}>
                                            <p className="info"> {puesto} </p>
                                        </Column>
                                    </Grid>
                                </SwitcherItem>
                                <SwitcherItem>
                                    <Grid>
                                        <Column lg={16} md={16} sm={16}>
                                            <p className="info">RFC: {rfc} </p>
                                        </Column>
                                    </Grid>
                                </SwitcherItem>
                                <br/><br/>
                                <hr />
                            </>
                        }
                        <SwitcherItem onClick={logout}>
                            <Grid>
                                <Column lg={13} md={13} sm={13}>
                                    Salir
                                </Column>
                                <Column lg={3} md={3} sm={3}>
                                    <Logout />
                                </Column>
                            </Grid>
                        </SwitcherItem>
                    </HeaderPanel>
                }
            </Header>
        )} />
    </>
};

export default HeaderCustom;